import React from 'react';
import { Grid } from '@material-ui/core';
import { SupportRequest } from '../../types';
import { DetailsField } from '../../DetailsField';

type DcimInfoProps = {
  request: SupportRequest;
};

const DcimInfo = ({ request }: DcimInfoProps) => {
  if (request.category !== 'DCIM' || !request.dcimDataCenterLocation) {
    return null;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <DetailsField
          label="Data Center Location"
          value={request.dcimDataCenterLocation}
        />
      </Grid>
      <Grid item xs={12}>
        <DetailsField label="URL" value={request.dcimUrl} />
      </Grid>
      <Grid item xs={12}>
        <DetailsField
          label="Profile ID [DCIM NA/APAC only] > Profile ID / Client ID"
          value={request.dcimProfileId}
        />
      </Grid>
      <Grid item xs={12}>
        <DetailsField
          label="DDIDs [DCIM Request only] > Data IDs"
          value={request.dcimDdidSample}
        />
      </Grid>
    </Grid>
  );
};

export default DcimInfo;
